var _path, _path2, _path3, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProductSelector(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 98,
    height: 86,
    viewBox: "0 0 98 86",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H98V86H0Z",
    fill: "#FFFFFF",
    fillRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.3012 0H89.6988C94.2834 0 98 3.7166 98 8.3012V86.9763H47.5053H0V8.3012C0 3.7166 3.7166 0 8.3012 0Z",
    fill: "#F4F5F7",
    fillRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M68.0011 39.7933H30.5306C29.8386 39.7933 29.2753 39.2505 29.2753 38.5828V24.5973H31.5678L31.7735 37.3716H66.7459V24.5973H69.2556V38.5828C69.2556 39.2505 68.6931 39.7933 68.0011 39.7933Z",
    fill: "#BBC0C4",
    fillRule: "evenodd"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.1045 17H75.3407V69H23.1045Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.9964 47.3605H50.4509V28.558H47.9964Z",
    fill: "#BBC0C4",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.591 31.4373H75.3414V17H60.591Z",
    fill: "#9EA6AE",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.9125 31.4373H26.9291C24.8169 31.4373 23.1045 29.7477 23.1045 27.6638V20.7743C23.1045 18.6896 24.8169 17 26.9291 17H33.9125C36.0247 17 37.7379 18.6896 37.7379 20.7743V27.6638C37.7379 29.7477 36.0247 31.4373 33.9125 31.4373Z",
    fill: "#9EA6AE",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.4898 17H45.0418L40.8174 24.2187L45.0418 31.4374H53.4898L57.7142 24.2187L53.4898 17Z",
    fill: "#9EA6AE",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.1085 57.3588C61.1085 63.8115 55.8063 69.043 49.2655 69.043C42.7254 69.043 37.4231 63.8115 37.4231 57.3588C37.4231 50.9053 42.7254 45.6745 49.2655 45.6745C55.8063 45.6745 61.1085 50.9053 61.1085 57.3588Z",
    fill: "#E25D6F",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductSelector);
export default __webpack_public_path__ + "static/media/product-selector.62a1d837432cb5675cf58f18d8dec863.svg";
export { ForwardRef as ReactComponent };